import styled, { keyframes } from 'styled-components';

export const FormWrap = styled.div`
  position: relative;
  input, textarea {
    border: none;
    background-color: transparent;
    &:focus-visible {
      outline: none;
      background-color: rgba(0, 0, 0, 0.07);
    }
    .dark-bg & {
      color: ${(p) => p.theme.palette.darkBgText};
      &:focus-visible {
        outline: none;
        background-color: rgba(255, 255, 255, 0.3);
      }
    }
  }
  input {
    border-bottom: 2px solid ${(p) => p.theme.palette.primary};
    font-weight: bold;
    border-radius: 2px 2px 0 0;
    opacity: 0.9;
    &[type="file"] {
      font-weight: normal;
      border-bottom: none;
    }
    .dark-bg & {
      border-bottom: 2px solid white;
    }
  }
  textarea {
    box-sizing: border-box;
    width: 100%;
    height: 200px;
    padding: 0.5em;
    line-height: 1.4em;
    border-radius: 2px;
    background-color: rgba(0, 0, 0, 0.07);
    transition: background-color 0.3s;
    .dark-bg & {
      color: ${(p) => p.theme.palette.darkBgText};
      border-color: white;
    }
  }
`;

export const ValidationErrorComponent = styled.span`
  position: absolute;
  left: 0;
  bottom: -1.2rem;
  width: 100%;
  font-size: 1rem;
  text-align: right;
  color: red;
  animation: ${keyframes`
    from { opacity: 0; transform: translateX(10px) }
    to { opacity: 1; transform: translateX(0) }
  `} 1s both;
`;

export const FieldWrap = styled.div`
  position: relative;
  margin-bottom: 2.5em;
  input {
    box-sizing: border-box;
    width: 100%;
    padding: 0.5em;
  }
`;
export const FieldInnerWrap = styled.div`
  position: relative;
`;
export const Label = styled.label`
  position: absolute;
  left: 0;
  top: 0.65em;
  color: ${(p) => p.theme.palette.text};
  transition-property: transform, color;
  transition-duration: 0.4s;
  pointer-events: none;
  .dark-bg & {
    color: ${(p) => p.theme.palette.darkBgText};
  }
  &.focussed-or-has-value,
  &.type-file {
    transform: translateY(-2em);
    color: ${(p) => p.theme.palette.text};
    .dark-bg & {
      color: ${(p) => p.theme.palette.darkBgText};
    }
  }
  &.type-textarea {
    left: 0.5em;
    &.focussed-or-has-value {
      transform: translate(-0.5em, -2em);
    }
  }
`;

export const ConsentLabel = styled.label`
  flex: 1 1 auto;
  padding-bottom: 5px;
  font-style: italic;
  font-size: 1rem;
  margin-right: 0.5em;
  text-align: right;
`;

export const ConsentInnerWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  && > input {
    width: auto;
    flex: 0 1 auto;
  }
  > label {
    padding: 0;
  }
`;
